module.exports = __webpack_public_path__ + "static/img/shareDownloadBg.0bde543.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/shareDownloadBg.png
// module id = pnni
// module chunks = 0